import { useMemo } from "react";

const useTranslation = (pathname, componentName) => {
  const translations = require(`../translations/${localStorage.getItem(
    "lang"
  )}.new`).default;

  return useMemo(
    () => translations[pathname][componentName],
    [translations, pathname, componentName]
  );
};

export default useTranslation;
